import { useDispatch } from "react-redux";

import { trackEventForAdoption } from "../adoption";

import {
  PAGE_VIEWED,
  TRACK_CONVERSATION_PREVIEW_SCREEN_VIEW,
  TRACK_CONVERSATION_VIEWED_EVENT,
} from "src/constants/adoption/eventTypes";

export const useConversationAdoption = () => {
  const dispatch = useDispatch();

  const trackPageViewed = (sreenName: string) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: sreenName,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackPreviewClicked = () => {
    const event = {
      event: "Page Viewed",
      properties: {
        screen_name: TRACK_CONVERSATION_PREVIEW_SCREEN_VIEW,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackConversationViewed = () => {
    const event = {
      event: TRACK_CONVERSATION_VIEWED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };
  return {
    trackPageViewed,
    trackPreviewClicked,
    trackConversationViewed,
  };
};
